// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__-3nHV","selects":"Documents_selects__gOWSR"};